import { render, staticRenderFns } from "./EmbeddedApp.vue?vue&type=template&id=f25483ce&"
import script from "./EmbeddedApp.vue?vue&type=script&lang=js&"
export * from "./EmbeddedApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports